function NewsItem({ data }) {

    const handleSubmit = (e) => {
        e.preventDefault()

    }

    return (
            <div className="card margin-right">
                <div className="news-card-details">
                    <img className='responsive' src={data.image} alt="" />
                    <p className="primary-clr">By Admin <span className="comments">Collins M</span>
                    </p>
                    <h5>Application is ready for lauch on Play store</h5>
                    <div className="read-more-btn">Done <a onClick={(e) => handleSubmit(e)} href='/' className="info"><i
                        className="fa-solid fa-arrow-right"></i></a></div>
                </div>
            </div>
    )
}

export default NewsItem
